import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useSWRAsyncData } from '@backmarket/nuxt-module-http-v2/useSWRAsyncData'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import type { Favorite } from '~/api/favorites/types'

import { LOG_ERROR_MESSAGE } from '../Favorites.constants'

/**
 * Fetches the list of favorites for the authenticated user with SWR caching.
 *
 * @param options - Configuration options
 * @param options.onDataUpdated - Callback executed when data is updated
 * @returns Object with data, error, hasFetchedOnce, and other useSWRAsyncData properties
 */
export function useFetchFavorites({
  onDataUpdated,
}: {
  onDataUpdated?: (data: Favorite[] | null | undefined) => void
}) {
  const $httpFetch = useHttpFetch()
  const logger = useLogger()

  return useSWRAsyncData(
    'favorites',
    () =>
      $httpFetch('/my-favorites/favorites', {
        onResponseError: () => {
          logger.error(LOG_ERROR_MESSAGE.FETCH, {
            owners: ['bot-squad-lifecycle-front'],
          })
        },
      }),
    {
      onDataUpdated,
    },
  )
}
